// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__6iNyS","lastLink":"HeadPage_lastLink__-MW19"};